import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import { LoginPage, RegisterPage } from "./pages/Auth";
import Home from "./pages/Home";
import Scan from "./pages/Scan";
import ScanNearby from "./pages/ScanNearby";
import NearbyList from "./pages/NearbyList";
import LiveRoom from "./pages/LiveRoom";
import VibeDetail from "./pages/VibeDetail";
import Interested from "./pages/Interested";
import Inbox from "./pages/Inbox";
import MatchCelebration from "./pages/Match";
import Chat from "./pages/Chat";
import Vault from "./pages/Vault";
import VaultPin from "./pages/VaultPin";
import { SettingsPage, PrivacyPage } from "./pages/Settings";
import Calculator from "./pages/Calculator";
import Admin from "./pages/Admin";
import MatchNotifier from "./components/app/MatchNotifier";
import { ForcePasswordGate } from "./components/app/ChangePasswordForm";
import { CallProvider } from "./context/CallContext";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#050505] text-zinc-500">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#1A1A1A", color: "white", border: "1px solid rgba(230,0,0,0.3)" } }} />
      <BrowserRouter>
        <CallProvider>
        <MatchNotifier />
        <ForcePasswordGate />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/home" element={<Protected><Home /></Protected>} />
          <Route path="/scan" element={<Protected><Scan /></Protected>} />
          <Route path="/scan-nearby" element={<Protected><ScanNearby /></Protected>} />
          <Route path="/nearby-list" element={<Protected><NearbyList /></Protected>} />
          <Route path="/live-room" element={<Protected><LiveRoom /></Protected>} />
          <Route path="/vibe/:id" element={<Protected><VibeDetail /></Protected>} />
          <Route path="/interested" element={<Protected><Interested /></Protected>} />
          <Route path="/inbox" element={<Protected><Inbox /></Protected>} />
          <Route path="/match/:id" element={<Protected><MatchCelebration /></Protected>} />
          <Route path="/chat/:id" element={<Protected><Chat /></Protected>} />
          <Route path="/vault/pin" element={<Protected><VaultPin /></Protected>} />
          <Route path="/vault" element={<Protected><Vault /></Protected>} />
          <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
          <Route path="/settings/privacy" element={<Protected><PrivacyPage /></Protected>} />
          <Route path="/disguise/calculator" element={<Calculator />} />
          <Route path="/admin" element={<Protected><Admin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </CallProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
